<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Dichiarazione Imballi
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-10"
            @click="showPreviewEtichette"
            v-bind="attrs"
            v-on="on"
            small
          >
            <v-icon color="success"> mdi-printer </v-icon>
          </v-btn>
        </template>
        <span>Invia Stampa</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="ristampaMasterAttuale" v-bind="attrs" v-on="on" small>
            <v-icon color="primary"> mdi-printer-pos-refresh </v-icon>
          </v-btn>
        </template>
        <span>Ristampa Master</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!--<DataMatrixReader
        class="mr-5"
        ref="qr"
        :custom_background="'orange'"
        :custom_color="'black'"
        v-on:detectQrCode="getFamigliaEtichette"
        @clickChiudi="qr_attivo = false"
      />-->

      <DataMatrixReader
        ref="qr"
        v-on:detectQrCode="detectQrCode"
        @clickChiudi="qr_attivo = false"
      />

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" v-bind="attrs" v-on="on" small>
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <!-- <v-row align="center" justify="center">
        <v-col cols="6">
          <v-autocomplete
            :items="articolo_packaging"
            label="Packaging"
            item-text="cod_articolo_packaging"
            item-value="id_articolo_packaging"
            return-object
            v-model="obj_packaging"
          ></v-autocomplete>
        </v-col>
      </v-row> -->
    <v-data-table :headers="headers_imballi" :items="items_imballi">
      <!-- Checkbox di selezione -->
      <template v-slot:[`item.check`]="{ item }">
        <v-icon
          @click="setItemSelezionato(item)"
          :color="item.check === 1 ? 'success' : ''"
          :key="key_checkbox"
          >{{
            item.check === 1
              ? "mdi-checkbox-marked"
              : "mdi-checkbox-blank-outline"
          }}
        </v-icon>
      </template>

      <!-- Colonna del tipo standard / alternativo -->
      <template v-slot:[`item.predefinito`]="{ item }">
        <span v-if="item.predefinito == 1"><b>Standard</b></span>
        <span v-else>Alternativo</span>
      </template>
    </v-data-table>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog v-model="dialog_risme_etichette" width="600">
      <v-card>
        <!-- Toolbar del dialog -->
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">
            Etichette Generate
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_risme_etichette = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col cols="4" v-for="(elem, i) in items_risme_etichette" :key="i">
              <!-- Sezione della miniatura + cod_report -->
              <div>
                <!-- Sezione della miniatura -->
                <div>
                  <v-icon
                    @click="showPdfViewer(elem)"
                    color="error"
                    x-large
                    style="font-size: 100px"
                  >
                    mdi-file-pdf-box
                  </v-icon>
                </div>
                <!-- Sezione del cod_report -->
                <div>
                  <span>
                    <b>{{ elem.des }}</b>
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog v-model="dialog_preview" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogPreview"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-col cols="12">
          <iframe
            :src="iframeUrl"
            frameborder="0"
            style="height: 70vh !important; width: 750px !important"
          >
          </iframe>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- DIALOG CONFERMA -->
    <v-dialog v-model="dialog_conferma_contenitore" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Registrazione
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="confermaSalvataggio('')"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogConferma"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 17px">
            Sei veramente sicuro di voler confermare i dati appena inseriti?<br />
            <span style="font-size: 20px">
              <b>{{
                workorder.qta_realizzabile != null &&
                qr_code_sel.quantita > workorder.qta_realizzabile &&
                qr_code_sel.tipo_etichetta.toUpperCase() === "SLAVE"
                  ? `La materia prima attualmente impegnata permette di dichiarare solo ${workorder.qta_realizzabile} unità di produzione per questo contenitore.`
                  : ""
              }}</b>
            </span>
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma chiusura dell'imballo -->
    <v-dialog v-model="conferma_chiusura_imballo" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Chiusura Imballo
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler chiudere l'imballo selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_chiusura_imballo = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="confermaSalvataggio('S')" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Finestra di dialogo degli impegni insufficienti -->
    <v-dialog persistent v-model="avviso_impegno_insufficiente" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impegni Insufficienti
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            La quantità totale di prodotto finito per questo imballo eccede
            l'attuale capacità di produzione in base agli impegni effettuati. Si
            vuole procedere?
          </span>
          <br />
          <div style="color: rgb(0, 0, 0); font-size: 18px; margin-top: 20px">
            <b>
              Quantità massima producibile: {{ workorder.qta_realizzabile }}
            </b>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <!-- Bottone di conferma -->
                <v-btn
                  class="mr-5"
                  @click="avviso_impegno_insufficiente = false"
                  small
                >
                  <span style="color: #4caf50; font-size: 15px">Sì</span>
                </v-btn>

                <!-- Bottone di rifiuto -->
                <v-btn class="mr-5" @click="annullaSelezioneLabel" small>
                  <span style="color: #ff5252; font-size: 15px">No</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog della visualizzazione dei seriali -->
    <v-dialog v-model="dialog_stampa_report" width="60vw" persistent>
      <StampaReportSeriali
        @chiudi="dialog_stampa_report = false"
        :id_report_custom="id_report_custom"
        :seriali="items_seriali"
        :visible="dialog_stampa_report"
        :workorder="obj_ristampa"
      />
    </v-dialog>

    <!-- Dialog della visualizzazione dei seriali -->
    <v-dialog v-model="dialog_selezione_etichetta" width="60vw" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title> Scelta Etichetta </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_selezione_etichetta = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <v-data-table
                  dense
                  :headers="headers_etichette_selezionabili"
                  :items="items_etichette_selezionabili"
                >
                  <!-- Bottone di stampa dell'etuchetta -->
                  <template v-slot:[`item.stampa`]="{ item }">
                    <v-btn
                      @click="
                        getFamigliaEtichette(item);
                        dialog_selezione_etichetta = false;
                      "
                    >
                      <v-icon color="primary">mdi-print</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import DataMatrixReader from "@/components/TOOLS/DataMatrixReader.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import StampaReportSeriali from "@/components/PRODUCTION/ProduzioneInsit/StampaReportSeriali.vue";

class Imballo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }
  setCampi() {
    const campi = [
      { nome: "cod_contenitore", default_val: "" },
      { nome: "cod_imballo", default_val: "" },
      { nome: "id_articolo_contenitore", default_val: null },
      { nome: "id_articolo_imballo", default_val: null },
      { nome: "id_articolo_packaging", default_val: null },
      { nome: "predefinito", default_val: null },
      { nome: "qta_contenitore", default_val: null },
      { nome: "qta_imballo", default_val: null },
    ];
    return campi;
  }
}

class Qrcode {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }
  setCampi() {
    const campi = [
      { nome: "check_seriale", default_val: null },
      { nome: "cod_articolo", default_val: null },
      { nome: "cod_packaging", default_val: "" },
      { nome: "quantita", default_val: null },
      { nome: "seriale", default_val: null },
      { nome: "tipo_etichetta", default_val: null },
    ];
    return campi;
  }
}

export default {
  name: "StampaEtichetteComponent",
  components: {
    DataMatrixReader,
    SnackbarQV,
    StampaReportSeriali,
  },
  props: {
    workorder: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili
      obj_packaging: {},
      id_articolo_contenitore: null,
      id_report_custom: null,
      iframeUrl: null,
      imballo_sel: new Imballo(),
      key_checkbox: 0,
      num_contenitori: 1,
      obj_ristampa: new Object(),
      qr_code_sel: new Qrcode(),
      selected_pdf: null,

      // Modal
      avviso_impegno_insufficiente: false,
      conferma_chiusura_imballo: false,
      dialog_conferma_contenitore: false,
      dialog_preview: false,
      dialog_risme_etichette: false,
      dialog_selezione_etichetta: false,
      dialog_stampa_report: false,
      loading: false,

      // Array
      headers_etichette_selezionabili: [
        {
          text: "Stampa",
          value: "stampa",
          sortable: false,
          width: "100px",
        },
        {
          text: "Seriale",
          value: "seriale",
          sortable: false,
        },
        {
          text: "Data",
          value: "data",
          sortable: false,
        },
      ],
      items_etichette_selezionabili: new Array(),
      items_imballi: [],
      items_seriali: new Array(),
      items_risme_etichette: new Array(),
      headers_imballi: [
        {
          text: "",
          value: "check",
          sortable: false,
        },
        {
          text: "Tipologia",
          value: "predefinito",
          sortable: false,
        },
        {
          text: "Cod. Imballo",
          value: "cod_imballo",
          sortable: false,
        },
        {
          text: "Cod. Contenitore",
          value: "cod_contenitore",
          sortable: false,
        },
        {
          text: "Cont. in Imballo",
          value: "qta_imballo",
          sortable: false,
        },
        {
          text: "Pz. in Contenitore",
          value: "qta_contenitore",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    annullaSelezioneLabel() {
      this.items_imballi.forEach((e) => {
        e.check = 0;
      });

      this.key_checkbox = this.key_checkbox === 0 ? 1 : 0;
      this.avviso_impegno_insufficiente = false;
    },
    chiudiDialogConferma() {
      this.dialog_conferma_contenitore = false;
    },
    chiudiDialogPreview() {
      this.dialog_preview = false;
    },
    clickChiudi() {
      this.$emit("chiudi");
    },
    confermaSalvataggio(arg_forzatura) {
      this.dialog_conferma_contenitore = false;
      this.conferma_chiusura_imballo = false;

      if (
        this.workorder.qta_realizzabile == 0 &&
        this.workorder.materia_prima == 1
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità realizzabile è pari a 0 e non si può registrare."
        );
        return;
      }

      if (this.num_contenitori <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità dei contenitori deve essere maggiore di 0."
        );
        return;
      }

      if (this.qr_code_sel.quantita <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare la quantità di pezzi per contenitore."
        );
        return;
      }

      /* Controllo che se il WO vuole prelievo componenti, la
       * registrazione non ecceda la quantità realizzabile. */
      /*if (
        this.qr_code_sel.quantita * this.num_contenitori >
          this.workorder.qta_realizzabile &&
        this.workorder.materia_prima === 1 &&
        this.qr_code_sel.tipo_etichetta.toUpperCase() === "SLAVE"
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `I pezzi registrati non possono essere superiori alla quantità realizzabile (${
            this.workorder.qta_realizzabile == null
              ? 0
              : this.workorder.qta_realizzabile
          } unità). Dichiarare nuovi componenti.`
        );
        return;
      }*/

      /* Controllo che ci sia fra le alternative di packaging
       * una che corrisponde a quella che è segnata nel QR code.
       * Se non c'è mando un avviso e fermo tutto, se c'è mi
       * prendo il relativo id_articolo_packaging di riferimento
       * che serve al BE per fare i suoi ragionamenti. */
      let chk_pack_exists = false;

      this.items_imballi.forEach((i) => {
        if (i.cod_articolo_packaging == this.qr_code_sel.cod_packaging) {
          this.id_articolo_contenitore = i.id_articolo_packaging;
          chk_pack_exists = true;
        }
      });

      if (chk_pack_exists === false) {
        console.log(this.qr_code_sel.cod_packaging);
        this.$refs.SnackbarQV.print(
          "orange",
          "Nessuna fra le opzioni di packaging disponibili corrisponde al Cod. Packaging del QR Code: impossibile inviare i dati."
        );
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: this.workorder.id_macchina,
          id_commessa_dettaglio: this.workorder.id_commessa_dettaglio,
          id_contenitore: this.id_articolo_contenitore,
          qta_contenitori: this.num_contenitori,
          qta_master_riaperto:
            this.workorder.qta_master_riaperto != null &&
            this.workorder.qta_master_riaperto != ""
              ? this.workorder.qta_master_riaperto
              : 0,
          qta_pezzi:
            this.qr_code_sel.quantita > this.workorder.qta_realizzabile &&
            this.workorder.qta_realizzabile
              ? this.workorder.qta_realizzabile
              : this.qr_code_sel.quantita,
          seriale: this.qr_code_sel.seriale,
          tipo_avanzamento: this.workorder.tipo_avanzamento,
          tipo_etichetta:
            this.qr_code_sel.tipo_etichetta.toUpperCase() === "MASTER"
              ? 0
              : this.qr_code_sel.tipo_etichetta.toUpperCase() === "SLAVE"
              ? 1
              : "",
          forza_chiudi_imballo: arg_forzatura,
          id_causale: -99,
        },
      };

      this.loading = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result === "imballo non completo") {
              this.conferma_chiusura_imballo = true;
              this.loading = false;
            } else {
              this.$refs.SnackbarQV.print("success", `${res.data.result}`);
              this.loading = false;
            }
            this.$emit("registrazione_avvenuta");
          } else {
            this.loading = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(e.response.data.message).result}`
          );
        });
    },
    detectQrCode(arg) {
      // Controllo che il codice contenga il prefisso giusto.
      if (arg.includes("GETQRC") === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (intestazione non valida), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il cod. articolo giusto.
      if (arg.includes("(P)")) {
        this.qr_code_sel.cod_articolo = arg.split("(P)")[1].split(";")[0];
        if (this.qr_code_sel.cod_articolo != this.workorder.cod_articolo) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Il codice articolo dell'etichetta '${this.qr_code_sel.cod_articolo}' non corrisponde al codice articolo che si vuole registrare '${this.workorder.cod_articolo}'.`
          );
          return;
        }
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Cod. Articolo), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il cod. packaging giusto.
      if (arg.includes("(K)")) {
        this.qr_code_sel.cod_packaging = arg.split("(K)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Cod. Packaging), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga l'informazione di quantità.
      if (arg.includes("(Q)")) {
        this.qr_code_sel.quantita = arg.split("(Q)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessuna Quantità), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il tipo etichetta.
      if (arg.includes("(T)")) {
        this.qr_code_sel.tipo_etichetta = arg.split("(T)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Tipo Etichetta), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga un seriale e che sia un seriale libero.
      if (arg.includes("(S)")) {
        this.qr_code_sel.seriale = arg.split("(S)")[1].split(";")[0];
        if (this.qr_code_sel.seriale != "") {
          this.loading = true;
          // Chiamata che controlla il seriale
          let request = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "checknumeroseriale",
              token: localStorage.user_token,
              seriale: this.qr_code_sel.seriale,
            },
          };
          this.$store
            .dispatch("api", request)
            .then((res) => {
              if (res.status === 200) {
                this.loading = false;
                this.qr_code_sel.check_seriale =
                  res.data.result[0].seriale_valido;

                this.qr_attivo = true;
                if (this.qr_code_sel.check_seriale == "true") {
                  this.dialog_conferma_contenitore = true;
                } else {
                  this.$refs.SnackbarQV.print(
                    "error",
                    `Il seriale risulta già usato da ${
                      res.data.result[0].nominativo
                    } in data ${this.formatData(res.data.result[0].data)}.`
                  );
                }
              } else {
                this.loading = false;
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Errore di comunicazione col server, non è stato possibile ottenere i dati."
                );
              }
            })
            .catch((e) => {
              this.loading = false;
              console.error(e);
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile ottenere i dati."
              );
            });
        }
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun seriale), impossibile acquisire i dati."
        );
        return;
      }
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        return strRes;
      }
    },
    getFamigliaEtichette(arg) {
      // Controllo che ci sia il seriale.
      if (!arg.includes("(S)")) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun seriale), impossibile acquisire i dati."
        );
        return;
      }

      const seriale_tmp = arg.split("(S)")[1].split(";")[0];

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getfamigliaetichette",
          token: localStorage.user_token,
          seriale: seriale_tmp,
        },
      };

      this.loading = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            if (res.data.result.length == 1) {
              this.ristampaEtichettaSelezionata(res.data.result[0]);
            } else {
              this.items_etichette_selezionabili = new Array();
              this.items_etichette_selezionabili = res.data.result;
              this.dialog_selezione_etichetta = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getImballi() {
      let getPackaging = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getlabelmasterslave",
          token: localStorage.getItem("user_token"),
          id_articolo: this.workorder.id_articolo,
        },
      };
      this.$store
        .dispatch("api", getPackaging)
        .then((res) => {
          if (res.status === 200) {
            this.items_imballi = Array.from(res.data.imballi);
            this.items_imballi.sort((a, b) => b.predefinito - a.predefinito);
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    registraEStampa(arg) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "registraestampa",
          token: localStorage.user_token,
          nome_parametro_seriale: "@id_articolo",
          dati_report: {
            cod_report: arg.cod_report,
            parametri: [
              {
                parametro: "@id_articolo_packaging",
                valore: this.imballo_sel.id_articolo_packaging,
              },
              {
                parametro: "@seriale",
                valore: arg.seriale,
              },
              {
                parametro: "@cod_macchina",
                valore: `${this.workorder.cod_macchina}`,
              },
              {
                parametro: "@cod_articolo",
                valore: `${this.workorder.cod_articolo}`,
              },
              {
                parametro: "@quantita",
                valore: `${this.workorder.quantita}`,
              },
              {
                parametro: "@pagine_slave",
                valore: arg.nr,
              },
              {
                parametro: "@cod_articolo_packaging",
                valore: `${this.imballo_sel.cod_contenitore}`,
              },
              {
                parametro: "@id_utente",
                valore: localStorage.id,
              },
            ],
          },
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;

          if (res.status === 200) {
            if (
              "tipo_messaggio" in res.data &&
              "query_messaggio" in res.data &&
              res.data.tipo_messaggio == 1
            ) {
              this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
            }

            const response = res.data.result;
            const byteCharacters = atob(response);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: "application/pdf",
            });
            const blobUrl = URL.createObjectURL(blob);
            this.items_risme_etichette.push({
              cod_report: arg.cod_report,
              base64: blobUrl,
              des: arg.des,
            });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Impossibile generare etichetta"
            );
            return false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Impossibile generare etichetta"
            );
          }
          return false;
        });
    },
    ristampaEtichettaSelezionata(arg) {
      this.id_report_custom = arg.id_report;
      this.items_seriali = [{ id: "" }];
      this.obj_ristampa = {
        id_articolo_packaging: arg.id_articolo_packaging,
        cod_macchina: this.workorder.cod_macchina,
        cod_articolo: this.workorder.cod_articolo,
        quantita: arg.qta_contenitore,
        cod_contenitore: arg.cod_articolo_packaging,
        id_personale: arg.id_personale,
        seriale_custom: arg.seriale,
      };
      this.dialog_stampa_report = true;
    },
    ristampaMasterAttuale() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getidreport",
          token: localStorage.user_token,
          id_commessa_dettaglio: this.workorder.id_commessa_dettaglio,
        },
      };

      this.loading = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            // Se c'è un messaggio dal BE lo stampo.
            if (res.data.message != "" && res.data.message != null) {
              this.$refs.SnackbarQV.print("orange", res.data.message);
              return;
            }

            // Se è tutto ok procedo a ristampare il master.
            this.id_report_custom = res.data.result[0].id_report;
            this.items_seriali = [{ id: "" }];
            this.obj_ristampa = {
              id_articolo_packaging: res.data.result[0].id_articolo_packaging,
              cod_macchina: this.workorder.cod_macchina,
              cod_articolo: this.workorder.cod_articolo,
              quantita: res.data.result[0].qta_contenitore,
              cod_contenitore: res.data.result[0].cod_articolo_packaging,
              id_personale: res.data.result[0].id_personale,
              seriale_custom: res.data.result[0].seriale,
            };
            this.dialog_stampa_report = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    setItemSelezionato(arg) {
      /* Quando flaggo una etichetta di insit per stamparla,
       * e mi accorgo che i pezzi moltiplicati per le scatole
       * fanno più della capacità attuale di produrre, apro una
       * finestra di dialogo di avviso. */
      if (
        arg.check != 1 &&
        this.workorder.qta_realizzabile != null &&
        arg.qta_imballo * arg.qta_contenitore > this.workorder.qta_realizzabile
      ) {
        this.avviso_impegno_insufficiente = true;
      }

      this.items_imballi.forEach((e) => {
        if (e.id_articolo_packaging === arg.id_articolo_packaging) {
          e.check = e.check === 1 ? 0 : 1;
        } else {
          e.check = 0;
        }
      });

      this.key_checkbox = this.key_checkbox === 0 ? 1 : 0;
    },
    showPdfViewer(arg) {
      this.iframeUrl = arg.base64;
      this.dialog_preview = true;
    },
    showPreviewEtichette() {
      this.imballo_sel = new Imballo();

      let chk_item_sel = false;
      this.items_imballi.forEach((e) => {
        if (e.check == 1) {
          chk_item_sel = true;
          this.imballo_sel = new Imballo(e);
        }
      });

      if (chk_item_sel === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare un imballo per stampare le relative etichette."
        );
        return;
      }

      this.loading = true;

      const request0 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getseriale",
          token: localStorage.user_token,
          id_articolo_packaging: this.imballo_sel.id_articolo_packaging,
        },
      };

      this.$store
        .dispatch("api", request0)
        .then(async (res0) => {
          if (res0.status === 200) {
            const res = JSON.parse(res0.data.result);

            // Resetto l'array delle risme di etichette.
            this.items_risme_etichette = new Array();

            for (let i = 0; i < res.length; i++) {
              await this.registraEStampa(res[i]);
            }

            this.dialog_risme_etichette = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile ottenere i dati."
            );
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile ottenere i dati."
          );
        });
    },
  },
  mounted() {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getImballi();
          this.imballo_sel = new Imballo();
          this.qr_code_sel = new Qrcode();
          this.id_articolo_contenitore = null;
          this.num_contenitori = 1;
        }
      },
    },
  },
};
</script>
<style scoped>
</style>